import { Alert, Link, Paragraph } from "@digdir/designsystemet-react";
import { ExternalLinkIcon } from "@navikt/aksel-icons";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useRouter } from "@tanstack/react-router";
import { useEffect } from "react";
import { authHttpClient } from "@/api/client";
import {
  getSelskapsportalVarslerGlobalOptions,
  getSelskapsportalVarslerGlobalQueryKey,
} from "@/api/generated/@tanstack/react-query.gen";
import { formatDateString } from "@/utils/dateTimeUtils";

const queryOptions = {
  client: authHttpClient,
};
var queryKey = getSelskapsportalVarslerGlobalQueryKey(queryOptions);

export const GlobaltVarsel = () => {
  const router = useRouter();
  const queryClient = useQueryClient();
  const { data, isLoading, error } = useQuery({
    ...getSelskapsportalVarslerGlobalOptions(queryOptions),
    staleTime: 60 * 1000, // 1 minute cache
  });

  useEffect(() => {
    const unsub = router.subscribe("onBeforeLoad", () => {
      queryClient.refetchQueries({ queryKey, stale: true });
    });

    return () => unsub();
  }, [router, queryClient]);

  var varsler = data?.varsel || [];

  if (isLoading || error || !data || varsler.length === 0) {
    return null;
  }

  const typeToColor = (type: string | undefined) => {
    switch (type) {
      case "Error":
        return "danger";
      case "Warning":
        return "warning";
      default:
        return "info";
    }
  };

  return (
    <section className="w-full max-w-page mx-auto px-5 sm:px-10 pt-5 space-y-5">
      {varsler.map((varsel) => (
        <Alert
          key={varsel.melding}
          data-color={typeToColor(varsel.type)}
          className="max-w-page mx-auto space-y-3 flex flex-wrap gap-4 items-baseline"
        >
          <Paragraph className="text-pretty whitespace-pre-line w-fit m-0">
            {varsel.melding}
          </Paragraph>

          <div className="flex gap-4 items-baseline flex-wrap">
            {varsel.merInfoUrl && (
              <Link href={varsel.merInfoUrl} target="_blank" rel="noreferrer">
                Mer info <ExternalLinkIcon fontSize={"1.5rem"} />
              </Link>
            )}
            <Paragraph className="text-sm m-0">
              {formatDateString(varsel.validFrom, "short", true)}
            </Paragraph>
          </div>
        </Alert>
      ))}
    </section>
  );
};
